import { useRouter } from "@tanstack/react-router";
import type { JSX } from "react";
import { type ReactNode, useEffect, useState } from "react";
import Tabs from "@/components/ui/tabs";

export interface HashTab {
  label: string;
  value: string;
  content: ReactNode;
}

interface HashTabsProps {
  tabs: HashTab[];
}

export default function HashTabs(props: HashTabsProps): JSX.Element {
  const router = useRouter();

  const currentHash = (): string => {
    const auxHash = router.state.location.hash.replace("#", "").trim();
    return auxHash || props.tabs[0]?.value || "";
  };

  const [activeTab, setActiveTab] = useState<string>(currentHash);

  useEffect(() => {
    if (props.tabs.some((tab) => tab.value === currentHash())) {
      setActiveTab(currentHash);
    }
  }, [currentHash]);

  const handleTabChange = async (value: string): Promise<void> => {
    setActiveTab(value);
    await router.navigate({ hash: value, replace: true });
  };

  return (
    <Tabs defaultValue={activeTab}>
      <Tabs.List>
        {props.tabs.map((tab) => (
          <Tabs.TabsTrigger
            key={tab.value}
            isActive={currentHash() == tab.value}
            value={tab.value}
            onClick={async () => {
              await handleTabChange(tab.value);
            }}
          >
            {tab.label}
          </Tabs.TabsTrigger>
        ))}
      </Tabs.List>
      <Tabs.Body>
        {props.tabs.map((tab) => (
          <Tabs.Content key={tab.value} title={tab.label} value={tab.value}>
            {tab.content}
          </Tabs.Content>
        ))}
      </Tabs.Body>
    </Tabs>
  );
}
